import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import MachineryReportSheet from "@/components/MachineryReportSheet";
import { Printer, ArrowLeft, Share2 } from "lucide-react";
import { toast } from "sonner";

export default function MachineryReport() {
  const { id } = useParams();
  const [report, setReport] = useState(null);
  const [error, setError] = useState("");

  const load = async () => {
    try {
      const { data } = await api.get(`/machinery/reports/${id}`);
      setReport(data);
    } catch (err) {
      setError(err.response?.data?.detail || "No se pudo cargar el reporte");
    }
  };
  useEffect(() => { load(); }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  const submitSignature = async (role, dataUrl, name) => {
    try {
      await api.post(`/machinery/reports/${id}/sign`, { role, signature: dataUrl, signed_name: name || undefined });
      toast.success("Firma guardada");
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "No se pudo guardar la firma");
      throw e;
    }
  };

  const share = async () => {
    try {
      const { data } = await api.post(`/machinery/reports/${id}/share`);
      const url = `${window.location.origin}/firma/maquinaria/${data.token}`;
      try { await navigator.clipboard.writeText(url); } catch { /* noop */ }
      toast.success("Enlace de firma copiado (válido 7 días). Compártelo por WhatsApp.");
      window.open(`https://wa.me/?text=${encodeURIComponent(`Firma de conformidad — Reporte de maquinaria "${report.machine_name}" (${report.period_start} → ${report.period_end}): ${url}`)}`, "_blank");
    } catch (e) {
      toast.error(e.response?.data?.detail || "No se pudo generar el enlace");
    }
  };

  if (error) return <div className="min-h-screen flex items-center justify-center text-slate-300">{error}</div>;
  if (!report) return <div className="min-h-screen flex items-center justify-center text-slate-400 label-mono">Cargando…</div>;

  return (
    <div className="min-h-screen" style={{ background: "#0a0f1d" }} data-testid="machinery-report-page">
      <div className="no-print sticky top-0 z-10 px-6 py-3 flex items-center justify-between gap-2 flex-wrap"
        style={{ borderBottom: "1px solid var(--border)", background: "rgba(5,8,18,0.9)", backdropFilter: "blur(8px)" }}>
        <button onClick={() => window.history.back()} className="btn-ghost px-3 py-1.5 text-xs uppercase tracking-widest font-semibold rounded-sm flex items-center gap-2">
          <ArrowLeft className="w-4 h-4" /> Volver
        </button>
        <div className="flex items-center gap-2">
          <button data-testid="share-machinery-report-btn" onClick={share} className="btn-ghost px-4 py-2 text-xs uppercase tracking-widest font-semibold rounded-sm flex items-center gap-2" style={{ color: "var(--green)", borderColor: "var(--green)" }}>
            <Share2 className="w-4 h-4" /> Compartir para firmar
          </button>
          <button data-testid="print-machinery-report-btn" onClick={() => window.print()} className="btn-primary px-4 py-2 text-xs uppercase tracking-widest font-semibold rounded-sm flex items-center gap-2">
            <Printer className="w-4 h-4" /> Imprimir / Guardar PDF
          </button>
        </div>
      </div>
      <div className="py-8 px-4">
        <MachineryReportSheet report={report} submitSignature={submitSignature} />
      </div>
    </div>
  );
}
